import React from 'react';
import { Box, Grid, Typography, Paper } from '@mui/material';
import { format } from '../../common/utils/common.util';
import { BaseInvoiceDTO } from './invoice.type';

interface TotalBalanceDueProps {
  invoices: BaseInvoiceDTO[];
  currentInvoice?: BaseInvoiceDTO;
}

const TotalBalanceDue: React.FC<TotalBalanceDueProps> = ({ invoices, currentInvoice }) => {
  const calculateTotalBalance = () => {
    // Calculate total from all invoices (past + current)
    const totalBalance = invoices.reduce((sum, invoice) => {
      const invoiceBalance = Number(invoice.invoice.invoiceAmount) - Number(invoice.invoice.paidAmount);
      return sum + invoiceBalance;
    }, 0);

    return totalBalance;
  };

  const totalBalance = calculateTotalBalance();

  return (
    <Paper elevation={1} sx={{ p: 0, mb: 2, borderRadius: 2, overflow: 'hidden' }}>
      <Box
        sx={{
          p: 2,
          backgroundColor: 'grey.100',
          fontWeight: 'bold',
        }}
      >
        <Grid container spacing={2} alignItems='center'>
          <Grid size={{ xs: 10 }} />
          <Grid size={{ xs: 2 }}>
            <Typography variant='body1' fontWeight='bold'>
              Total Balance Due
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ p: 2, borderTop: '1px solid', borderColor: 'divider' }}>
        <Grid container spacing={2} alignItems='center'>
          <Grid size={{ xs: 10 }} />
          <Grid size={{ xs: 2 }}>
            <Typography variant='body1' fontWeight='bold'>
              {format(totalBalance.toString(), 'currency')}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

export default TotalBalanceDue;
